import { Route, Routes } from 'react-router-dom';

import EnrollmentPage from './enrollment-page';

export default function Enrollments() {
    return (
        <Routes>
            <Route
                path="/enrollments/:enrollmentId"
                element={<EnrollmentPage />}
            />
        </Routes>
    );
}